export default __webpack_public_path__ + "static/media/iDocFont-20.7c539526.ttf";